import { Field, isVoidField } from '@formily/core';
import { observer, useField } from '@formily/react';
import React from 'react';
interface Item {
  value: string;
  label: string;
}

interface IProps {
  value?: any;
  onChange?: (items: Item[]) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: any;
  content?: string;
}

const Cmp = (props: any) => {
  return <div>{props.value}</div>;
};

export const Text: React.FC<IProps> = observer((props) => {
  const { onChange, value, disabled, style, content } = props;
  const field: any = useField<Field>();

  if (!isVoidField(field) && field?.pattern === 'readPretty') {
    return <Cmp />;
  }

  return (
    <div>
      <a aria-disabled={disabled} style={style}>
        {content}
      </a>
    </div>
  );
});
export default Text;
